import Swiper from "swiper"
import { FreeMode, Mousewheel, Pagination, Scrollbar } from "swiper/modules"
import { getCookie } from "../../js/utils/helper"

class cookmodeComponent {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("cookmode::initialize()")

		this._component = document.querySelector(".bb-cookmode")
		this._isInitialized = false

		this._isSecondary = document.querySelector(".bb-cookmode__secondary")
		this._wakeLock = null
		this._overlayOpenButton = this._component.querySelector(".bb-cookmode__button-container button")
		this._overlayCloseButton = this._component.querySelector(".bb-cookmode__overlay-container__close-button-container button")
		this._overlayContainer = this._component.querySelector(".bb-cookmode__overlay-container")

		this._initEvent()

		this._component.addEventListener("BBChangeVariantToOld", () => {
			this._changeSecondaryButtonToPrimary()
		})
	}

	_initEvent() {
		this._overlayOpenButton.addEventListener("click", () => {
			this._openCookmode()
			this._activateWakeLock()
		})

		this._overlayCloseButton.addEventListener("click", () => {
			this._closeCookmode()
			this._releaseWakeLock()
		})

		this.secondaryButtonEventsController = new AbortController()
		if(this._isSecondary) this._initSecondaryButton()
	}

	_initSecondaryButton() {
		const info = this._component.querySelector(".bb-cookmode__info")
		const infoClose = this._component.querySelector(".bb-cookmode__info-close")
		let hasScrolled = false

		if(info && infoClose) {
			document.addEventListener('scroll', () => {
				if (!hasScrolled) {
					hasScrolled = true
					const buttonContainer = this._component.querySelector(".bb-cookmode__button-container")
					buttonContainer.style.display = "flex"
					buttonContainer.classList.add("show")

					setTimeout(() => {
						if(!getCookie("hideInfoCookmode")) {
							if(info) this._openInfo(info)
						}
					}, 3000)
				}
			}, { signal: this.secondaryButtonEventsController.signal })

			infoClose.addEventListener("click", () => {
				document.cookie = "hideInfoCookmode=true; path=/"
				this._closeInfo(info)
			}, { signal: this.secondaryButtonEventsController.signal })

			info.addEventListener('click', (event) => {
				if(!event.target.classList.contains("bb-cookmode__info-close")) {
					this._openCookmode()
					this._activateWakeLock()
				}
			}, { signal: this.secondaryButtonEventsController.signal })
			if(this._component.dataset.renderAsPrimary === "true") this._changeSecondaryButtonToPrimary()
		}
	}

	_changeSecondaryButtonToPrimary() {
		this.secondaryButtonEventsController.abort()
		const info = this._component.querySelector(".bb-cookmode__info")
		if(info) info.remove()
		this._component.classList.add("bb-cookmode__primary")
		this._component.classList.remove("bb-cookmode__secondary")
		this._overlayOpenButton.querySelector(".bb-icon").classList.add("bb-icon--user-chef")
		this._overlayOpenButton.querySelector(".bb-icon").classList.remove("bb-icon--user-chef-cap-solid")
	}

	_openCookmode() {
		if (!this._isInitialized) {
			let pagination = []
			this._overlayContainer.querySelectorAll(".bb-cookmode__swiper-pagination-bullet").forEach((item) => {
				pagination.push(item)
			})
			this._initSwiper(pagination)
		}
		document.body.classList.add("modal-open")
		this._overlayContainer.style.display = "block"
		setTimeout(() => {
			this._overlayContainer.style.opacity = 1
		}, 20)
		this._isInitialized = true
	}

	_closeCookmode() {
		this._overlayContainer.style.opacity = 0
		setTimeout(() => {
			this._overlayContainer.style.display = "none"
			document.body.classList.remove("modal-open")
		}, 300)
	}

	_closeInfo(info) {
		info.style.opacity = 0
		setTimeout(() => {
			if(info) info.style.display = "none"
		}, 300)
	}

	_openInfo(info) {
		info.style.display = "flex"
		info.classList.add('show')
	}

	_initSwiper(pagination) {
		const paginationSwiper = this._controlPagination()

		const swiper = new Swiper(this._overlayContainer.querySelector(".swiper"), {
			modules: [Pagination],
			spaceBetween: 24,
			slidesPerView: 1,
			direction: "horizontal",
			mousewheel: {
				releaseOnEdges: true,
				sensitivity: 0.5,
				thresholdTime: 1200,
				thresholdDelta: 4,
			},
			slideClass: "bb-cookmode__preparation__step",
			pagination: {
				el: ".bb-cookmode__swiper-pagination",
				bulletClass: "bb-cookmode__swiper-pagination-bullet",
				bulletActiveClass: "bb-cookmode__swiper-pagination-bullet-active",
				type: "bullets",
				clickable: true,
				renderBullet: (index) => {
					return pagination[index].outerHTML
				},
			},
		})
		swiper.on("slideChange", (swiper) => {
			paginationSwiper.slideTo(swiper.activeIndex, 300)
		})
		this._initNestedSwipers()
	}

	_controlPagination() {
		const breakpoints = {
			360: {
				slidesPerView: 5,
			},
			576: {
				slidesPerView: 7,
			},
			1100: {
				slidesPerView: 9,
			},
			1600: {
				slidesPerView: 11,
			},
		}

		function checkBreakpoint(breakpointParams) {
			if (paginationSwiper.slidesEl.children.length < breakpointParams.slidesPerView) {
				paginationSwiperElement.classList.add("not-enough-slides")
			} else {
				paginationSwiperElement.classList.remove("not-enough-slides")
			}
		}

		let paginationSwiperElement = this._component.querySelector(".bb-cookmode__swiper-pagination").parentElement

		const paginationSwiper = new Swiper(paginationSwiperElement, {
			slideClass: "bb-cookmode__swiper-pagination-bullet",
			wrapperClass: "bb-cookmode__swiper-pagination",
			centeredSlides: true,
			centeredSlidesBounds: true,
			slideToClickedSlide: true,
			slidesPerView: 5,
			allowTouchMove: false,
			nested: true,
			breakpoints: breakpoints,
		})

		paginationSwiper.on("breakpoint", (swiper, breakpointParams) => {
			checkBreakpoint(breakpointParams)
		})

		if (paginationSwiper.currentBreakpoint !== "max")
			checkBreakpoint(breakpoints[paginationSwiper.currentBreakpoint])

		return paginationSwiper
	}
	_initNestedSwipers() {
		this._overlayContainer.querySelectorAll(".nested-swiper").forEach((element) => {
			new Swiper(element, {
				modules: [FreeMode, Mousewheel, Scrollbar],
				scrollbar: true,
				freeMode: true,
				slidesPerView: "auto",
				direction: "vertical",
				mousewheel: {
					releaseOnEdges: true,
					sensitivity: 0.25,
				},
				slideClass: "nested-swiper-slide",
				wrapperClass: "nested-swiper-wrapper",
				nested: true,
				createElements: true,
			})
		})
	}

	_activateWakeLock() {
       navigator.wakeLock.request("screen")
		   .then((lock)=> {
			   this._wakeLock = lock

			   lock.addEventListener("release", () => {
				   this._wakeLock = null
			   })
		   })
		   .catch(err => {
			   console.error(`${err.name}, ${err.message}`)
		   })
	}

	_releaseWakeLock() {
		if (this._wakeLock !== null) {
			this._wakeLock.release()
			this._wakeLock = null
		}
	}
}

export default cookmodeComponent
